import React, { useEffect } from 'react';
import { 
  Redirect, 
  BrowserRouter as Router,  
  Switch
} from 'react-router-dom';
import { firebase } from './firebase/firebaseConfig';
import { AuthRouter } from './routers/AuthRouter';
import { DashboardRouter } from './routers/DashboardRouter';
import PublicRoutes from './routers/PublicRoutes';
import PrivateRoutes from './routers/PrivateRoutes';
import { useDispatch, useSelector } from 'react-redux';
import { loginUser } from './actions/userActions';

const App = () => {
  const dispatch = useDispatch();
  const currentUserLogged = useSelector((state) => {
    console.log("state, ", state.user.userLogged);
    return state.user.userLogged
  } );

  useEffect(() => {
    try {
      firebase.auth().onAuthStateChanged(async user => {
        console.log("user auth", user?.uid);
        if (user?.uid) {
            console.log("user: ", user);
              const currentUser = await firebase.auth().currentUser;
              const t = await currentUser.getIdToken();
              if (t) {
                  // console.log(t, currentUser);
                  dispatch(loginUser({
                    token: t,
                    email: currentUser?.email,
                    active: currentUser?.emailVerified,
                    uuid: user?.uid
                  }));
              }
          } else {
            dispatch(loginUser({}));        }
      });
    } catch (error) {
      console.log("error: ", error);
    }
    
// eslint-disable-next-line react-hooks/exhaustive-deps
}, []);
  const style = {
    margin: 0, height: 'inherit'
  }
  return (
      <Router>
        <div style={style}>
          {/* {JSON.stringify(currentUserLogged, null, 4)} */}
          <Switch>
            <PublicRoutes
              path="/auth"
              // isAuthenticate = {initialState.state.currentUser?.token ? true : false}
              isAuthenticate = {currentUserLogged?.token}
              component={ AuthRouter }
            />
            <PrivateRoutes 
              path="/dashboard"
              isAuthenticate = {currentUserLogged?.token}
              // isAuthenticate = {initialState.state.currentUser?.token ? true : false}
              component={ DashboardRouter }
            />
            <Redirect to="/auth/login" />

          </Switch>
        </div>
      </Router>

  );
}

export default App;
